import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { SDInstitutionEnum } from './sd-stammdaten-plugin.js';

export const buildYourOwnAiStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::buildYourAi',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new BuildYourOwnAiStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(BuildYourOwnAiStammdaten.fields).filter(
      it => !['_id', '_class', 'userID', 'institutionID'].includes(it),
    );
  },
  classType: () => BuildYourOwnAiStammdaten,
};

export enum BuidYourOwnAiRoleEnum {
  BUILD_YOUR_OWN_AI_STUDENT = 'BUILD_YOUR_OWN_AI_STUDENT',
  BUILD_YOUR_OWN_AI_MENTOR = 'BUILD_YOUR_OWN_AI_MENTOR',
}
registerEnum({ enum: BuidYourOwnAiRoleEnum, name: 'BuidYourOwnAiRoleEnum' });

export enum BuildYourOwnAiAvailability {
  BUILD_YOUR_OWN_AI_MORNING = 'BUILD_YOUR_OWN_AI_MORNING',
  BUILD_YOUR_OWN_AI_AFTERNOON = 'BUILD_YOUR_OWN_AI_AFTERNOON',
  BUILD_YOUR_OWN_AI_WHOLE_DAY = 'BUILD_YOUR_OWN_AI_WHOLE_DAY',
}
registerEnum({ enum: BuildYourOwnAiAvailability, name: 'BuildYourOwnAiAvailability' });

@Entity()
export class BuildYourOwnAiStammdaten extends UserStammdaten {
  static override _class = 'BuildYourOwnAiStammdaten';

  override getTranslationNamespace() {
    return 'buildYourOwnAi';
  }

  @validate(nonOptional())
  @Field(type => BuidYourOwnAiRoleEnum)
  role: Maybe<BuidYourOwnAiRoleEnum>;

  @validate(nonOptional())
  @Field(type => SDInstitutionEnum)
  fachbereich: Maybe<SDInstitutionEnum>;

  @validate(nonOptional())
  @Field(type => BuildYourOwnAiAvailability)
  availability: Maybe<BuildYourOwnAiAvailability>;
}
